import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl
} from '@angular/forms';
import { select, Store } from '@ngrx/store';

import { NotificationService } from '../../../shared/services/notification.service';
import { LoginRequest } from '../../models/login.request';
import { AuthService } from '../../services/auth.service';
import * as fromShared from './../../../shared/store/reducers';
import * as fromLoginFeature from './../../../store';
import * as fromActionsAuth from './../../../store/actions';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private store: Store<fromShared.FeatureState>,
    private storeAuthFeature: Store<fromLoginFeature.AuthState>,
    private notificationService: NotificationService,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.createForm();
    this.storeAuthFeature
      .pipe(select(fromLoginFeature.selectUserLoaded))
      .subscribe(hasLoaded => {
        if (hasLoaded) {
          this.storeAuthFeature.dispatch(fromActionsAuth.goHome());
        }
      });
  }

  createForm() {
    this.loginForm = this.fb.group({
      username: [
        '',
        Validators.compose([Validators.required, Validators.email])
      ],
      password: ['', Validators.required]
    });
  }

  signIn() {
    if (this.loginForm.valid) {
      const { username, password } = this.loginForm.value;
      const request = new LoginRequest(username, password);
      this.store.dispatch(fromActionsAuth.login({ credentials: request }));
    }
  }

  onSuccessAuth({ token }) {
    this.authService.setSession(token);
    this.store.dispatch(fromActionsAuth.loginSuccess({ access_token: token }));
  }
  onErrorAuth(error) {
    this.notificationService.error(error.error.message);
  }

  getControl(nameControl: string): FormControl {
    return this.loginForm.get(nameControl) as FormControl;
  }

  getErrorByControl(nameControl: string, errorType: string) {
    const control = this.getControl(nameControl);
    return control.hasError(errorType) && control.touched;
  }
}
